import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from 'src/app/core/resources/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { City } from 'src/app/core/interfaces/city';
import { CityService } from '../city.service';
import { FormControl } from '@angular/forms';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-city-list',
  templateUrl: './city-list.component.html',
  styleUrls: ['./city-list.component.scss']
})
export class CityListComponent implements OnInit {

  pageKey = 1;
  pageSize = 25;
  listCities: City[];
  scrollDistance = 1;
  throttle = 300;
  enablePagingScroll = true;
  optionsCity: OptionsAutocomplete = {
    title: 'Buscar ciudad',
    requireFullCity: true
  }
  cityControl: FormControl = new FormControl();
  citySub: Subscription;
  transportNit: string = null;
  // Empresa que trae la URL (?transportCompanyId=): al volver del detalle o recargar se conserva la elegida.
  initialTransportNit: string = null;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cityService: CityService,
    private spinner: NgxSpinnerService,
    public utils: Utils,
  ) { }

  ngOnInit() {
    this.initialTransportNit = this.cityService.lastTransportCompanyId
      || this.route.snapshot.queryParams['transportCompanyId'] || null;
    this.setSubscriptionCity();
  }

  /**
   * La primera consulta la dispara app-transport-company-context al resolver
   * la empresa (la última elegida en Ciudades, la de la URL o la primera); cada
   * cambio reinicia la paginación y queda en la URL y en CityService para que
   * listado y detalle coincidan al ir y volver.
   */
  public onTransportCompanyChange(transportNit: string) {
    const isChange = this.transportNit !== null && this.transportNit !== transportNit;
    this.transportNit = transportNit;
    if (transportNit) this.cityService.lastTransportCompanyId = transportNit;
    // Lo escrito en "Buscar ciudad" y sus resultados eran de la empresa anterior.
    if (isChange) this.cityControl.setValue('');
    // "Buscar ciudad" consulta catalog/cities con la misma empresa que el listado.
    this.optionsCity.transportNit = transportNit || undefined;
    this.syncTransportNitInUrl(transportNit);
    this.pageKey = 1;
    this.listCities = [];
    this.enablePagingScroll = true;
    this.getCities();
  }

  /** replaceUrl: cambiar de empresa no agrega pasos al historial del navegador. */
  private syncTransportNitInUrl(transportNit: string) {
    if (!transportNit || this.route.snapshot.queryParams['transportCompanyId'] === transportNit) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { transportCompanyId: transportNit },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  public getCities() {
    this.spinner.show();
    const requestedTransportNit = this.transportNit;
    this.cityService.getAllCities(this.pageKey, this.pageSize, requestedTransportNit).toPromise()
      .then((success: City[]) => {
        // Respuesta de una empresa que ya no está seleccionada: no se mezcla.
        if (requestedTransportNit !== this.transportNit) return;
        if (!this.utils.isDefined(success) || success.length < 1) {
          this.enablePagingScroll = false;
        } else {
          if (this.listCities && this.listCities.length) {
            this.listCities = this.listCities.concat(success);
          } else {
            this.listCities = success;
          }
          if (success.length < this.pageSize) {
            this.enablePagingScroll = false;
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  setSubscriptionCity() {
    this.citySub = this.cityControl.valueChanges
      .subscribe(value => {
        if (value && value.id)
          this.router.navigate(['administration/cities/detail', value.id], this.transportNit ? { queryParams: { transportCompanyId: this.transportNit } } : {});
      })
  }

  onScrollDown() {
    if (this.enablePagingScroll) {
      this.pageKey++;
      this.getCities();
    }
  }

  ngOnDestroy() {
    if (this.citySub) this.citySub.unsubscribe();
  }
}
